import { d as P, a3 as rt, ac as cs, ad as hs, k as $, ae as Qt, af as te, Q as A, F as T, ag as ee, a7 as zt, ah as ls, Y as $e, $ as Ue, C as Ye, j as xt, h as Et, ai as se, aj as ds, D as Xe, p as Pt, ak as us, T as j, i as I, t as it, m as fs, n as gs, o as ps, v as z, a5 as ms, a6 as ie, a8 as ne, M as Ke, r as _s, E as mt, z as st, x as Lt, P as H, u as oe, l as xs, b as q, f as It, g as J, O as U, R as bs, S as G, U as ys, V as ae, W as vs, X as tt, Z as re, a0 as Xt, a9 as ks, aa as Ms, G as ws, I as qe, H as X, s as ce, a4 as Ss, ab as Ot, J as he, L as Ge, al as jt, a as yt, e as le, N as Ds, A as Os, B as Kt, am as As, c as de, K as Cs, a2 as ue, a1 as Es, aP as Ps, _ as Ls, aQ as Is } from "./index.es372.js";
import { aM as kn } from "./index.es372.js";
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class Rs {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, s, i) {
    const n = e.listeners[i], a = e.duration;
    n.forEach((r) => r({
      chart: t,
      initial: e.initial,
      numSteps: a,
      currentStep: Math.min(s - e.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = _s.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((s, i) => {
      if (!s.running || !s.items.length)
        return;
      const n = s.items;
      let a = n.length - 1, r = !1, c;
      for (; a >= 0; --a)
        c = n[a], c._active ? (c._total > s.duration && (s.duration = c._total), c.tick(t), r = !0) : (n[a] = n[n.length - 1], n.pop());
      r && (i.draw(), this._notify(i, s, t, "progress")), n.length || (s.running = !1, this._notify(i, s, t, "complete"), s.initial = !1), e += n.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let s = e.get(t);
    return s || (s = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, s)), s;
  }
  listen(t, e, s) {
    this._getAnims(t).listeners[e].push(s);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((s, i) => Math.max(s, i._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const s = e.items;
    let i = s.length - 1;
    for (; i >= 0; --i)
      s[i].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var K = /* @__PURE__ */ new Rs();
const fe = "transparent", Ts = {
  boolean(o, t, e) {
    return e > 0.5 ? t : o;
  },
  color(o, t, e) {
    const s = de(o || fe), i = s.valid && de(t || fe);
    return i && i.valid ? i.mix(s, e).hexString() : t;
  },
  number(o, t, e) {
    return o + (t - o) * e;
  }
};
class zs {
  constructor(t, e, s, i) {
    const n = e[s];
    i = yt([
      t.to,
      i,
      n,
      t.from
    ]);
    const a = yt([
      t.from,
      n,
      i
    ]);
    this._active = !0, this._fn = t.fn || Ts[t.type || typeof a], this._easing = le[t.easing] || le.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = s, this._from = a, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, s) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], n = s - this._start, a = this._duration - n;
      this._start = s, this._duration = Math.floor(Math.max(a, t.duration)), this._total += n, this._loop = !!t.loop, this._to = yt([
        t.to,
        e,
        i,
        t.from
      ]), this._from = yt([
        t.from,
        i,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, s = this._duration, i = this._prop, n = this._from, a = this._loop, r = this._to;
    let c;
    if (this._active = n !== r && (a || e < s), !this._active) {
      this._target[i] = r, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[i] = n;
      return;
    }
    c = e / s % 2, c = a && c > 1 ? 2 - c : c, c = this._easing(Math.min(1, Math.max(0, c))), this._target[i] = this._fn(n, r, c);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, s) => {
      t.push({
        res: e,
        rej: s
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", s = this._promises || [];
    for (let i = 0; i < s.length; i++)
      s[i][e]();
  }
}
class Fs {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!I(t))
      return;
    const e = Object.keys(P.animation), s = this._properties;
    Object.getOwnPropertyNames(t).forEach((i) => {
      const n = t[i];
      if (!I(n))
        return;
      const a = {};
      for (const r of e)
        a[r] = n[r];
      (q(n.properties) && n.properties || [
        i
      ]).forEach((r) => {
        (r === i || !s.has(r)) && s.set(r, a);
      });
    });
  }
  _animateOptions(t, e) {
    const s = e.options, i = Ns(t, s);
    if (!i)
      return [];
    const n = this._createAnimations(i, s);
    return s.$shared && Vs(t.options.$animations, s).then(() => {
      t.options = s;
    }, () => {
    }), n;
  }
  _createAnimations(t, e) {
    const s = this._properties, i = [], n = t.$animations || (t.$animations = {}), a = Object.keys(e), r = Date.now();
    let c;
    for (c = a.length - 1; c >= 0; --c) {
      const h = a[c];
      if (h.charAt(0) === "$")
        continue;
      if (h === "options") {
        i.push(...this._animateOptions(t, e));
        continue;
      }
      const l = e[h];
      let d = n[h];
      const u = s.get(h);
      if (d)
        if (u && d.active()) {
          d.update(u, l, r);
          continue;
        } else
          d.cancel();
      if (!u || !u.duration) {
        t[h] = l;
        continue;
      }
      n[h] = d = new zs(u, t, h, l), i.push(d);
    }
    return i;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const s = this._createAnimations(t, e);
    if (s.length)
      return K.add(this._chart, s), !0;
  }
}
function Vs(o, t) {
  const e = [], s = Object.keys(t);
  for (let i = 0; i < s.length; i++) {
    const n = o[s[i]];
    n && n.active() && e.push(n.wait());
  }
  return Promise.all(e);
}
function Ns(o, t) {
  if (!t)
    return;
  let e = o.options;
  if (!e) {
    o.options = t;
    return;
  }
  return e.$shared && (o.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function ge(o, t) {
  const e = o && o.options || {}, s = e.reverse, i = e.min === void 0 ? t : 0, n = e.max === void 0 ? t : 0;
  return {
    start: s ? n : i,
    end: s ? i : n
  };
}
function js(o, t, e) {
  if (e === !1)
    return !1;
  const s = ge(o, e), i = ge(t, e);
  return {
    top: i.end,
    right: s.end,
    bottom: i.start,
    left: s.start
  };
}
function Bs(o) {
  let t, e, s, i;
  return I(o) ? (t = o.top, e = o.right, s = o.bottom, i = o.left) : t = e = s = i = o, {
    top: t,
    right: e,
    bottom: s,
    left: i,
    disabled: o === !1
  };
}
function Je(o, t) {
  const e = [], s = o._getSortedDatasetMetas(t);
  let i, n;
  for (i = 0, n = s.length; i < n; ++i)
    e.push(s[i].index);
  return e;
}
function pe(o, t, e, s = {}) {
  const i = o.keys, n = s.mode === "single";
  let a, r, c, h;
  if (t === null)
    return;
  let l = !1;
  for (a = 0, r = i.length; a < r; ++a) {
    if (c = +i[a], c === e) {
      if (l = !0, s.all)
        continue;
      break;
    }
    h = o.values[c], J(h) && (n || t === 0 || ce(t) === ce(h)) && (t += h);
  }
  return !l && !s.all ? 0 : t;
}
function Ws(o, t) {
  const { iScale: e, vScale: s } = t, i = e.axis === "x" ? "x" : "y", n = s.axis === "x" ? "x" : "y", a = Object.keys(o), r = new Array(a.length);
  let c, h, l;
  for (c = 0, h = a.length; c < h; ++c)
    l = a[c], r[c] = {
      [i]: l,
      [n]: o[l]
    };
  return r;
}
function Bt(o, t) {
  const e = o && o.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function Hs(o, t, e) {
  return `${o.id}.${t.id}.${e.stack || e.type}`;
}
function $s(o) {
  const { min: t, max: e, minDefined: s, maxDefined: i } = o.getUserBounds();
  return {
    min: s ? t : Number.NEGATIVE_INFINITY,
    max: i ? e : Number.POSITIVE_INFINITY
  };
}
function Us(o, t, e) {
  const s = o[t] || (o[t] = {});
  return s[e] || (s[e] = {});
}
function me(o, t, e, s) {
  for (const i of t.getMatchingVisibleMetas(s).reverse()) {
    const n = o[i.index];
    if (e && n > 0 || !e && n < 0)
      return i.index;
  }
  return null;
}
function _e(o, t) {
  const { chart: e, _cachedMeta: s } = o, i = e._stacks || (e._stacks = {}), { iScale: n, vScale: a, index: r } = s, c = n.axis, h = a.axis, l = Hs(n, a, s), d = t.length;
  let u;
  for (let f = 0; f < d; ++f) {
    const g = t[f], { [c]: m, [h]: x } = g, p = g._stacks || (g._stacks = {});
    u = p[h] = Us(i, l, m), u[r] = x, u._top = me(u, a, !0, s.type), u._bottom = me(u, a, !1, s.type);
    const _ = u._visualValues || (u._visualValues = {});
    _[r] = x;
  }
}
function Wt(o, t) {
  const e = o.scales;
  return Object.keys(e).filter((s) => e[s].axis === t).shift();
}
function Ys(o, t) {
  return xt(o, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function Xs(o, t, e) {
  return xt(o, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function lt(o, t) {
  const e = o.controller.index, s = o.vScale && o.vScale.axis;
  if (s) {
    t = t || o._parsed;
    for (const i of t) {
      const n = i._stacks;
      if (!n || n[s] === void 0 || n[s][e] === void 0)
        return;
      delete n[s][e], n[s]._visualValues !== void 0 && n[s]._visualValues[e] !== void 0 && delete n[s]._visualValues[e];
    }
  }
}
const Ht = (o) => o === "reset" || o === "none", xe = (o, t) => t ? o : Object.assign({}, o), Ks = (o, t, e) => o && !t.hidden && t._stacked && {
  keys: Je(e, !0),
  values: null
};
class Ze {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = Bt(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && lt(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, s = this.getDataset(), i = (d, u, f, g) => d === "x" ? u : d === "r" ? g : f, n = e.xAxisID = z(s.xAxisID, Wt(t, "x")), a = e.yAxisID = z(s.yAxisID, Wt(t, "y")), r = e.rAxisID = z(s.rAxisID, Wt(t, "r")), c = e.indexAxis, h = e.iAxisID = i(c, n, a, r), l = e.vAxisID = i(c, a, n, r);
    e.xScale = this.getScaleForId(n), e.yScale = this.getScaleForId(a), e.rScale = this.getScaleForId(r), e.iScale = this.getScaleForId(h), e.vScale = this.getScaleForId(l);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && oe(this._data, this), t._stacked && lt(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), s = this._data;
    if (I(e)) {
      const i = this._cachedMeta;
      this._data = Ws(e, i);
    } else if (s !== e) {
      if (s) {
        oe(s, this);
        const i = this._cachedMeta;
        lt(i), i._parsed = [];
      }
      e && Object.isExtensible(e) && xs(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, s = this.getDataset();
    let i = !1;
    this._dataCheck();
    const n = e._stacked;
    e._stacked = Bt(e.vScale, e), e.stack !== s.stack && (i = !0, lt(e), e.stack = s.stack), this._resyncElements(t), (i || n !== e._stacked) && (_e(this, e._parsed), e._stacked = Bt(e.vScale, e));
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), s = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(s, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: s, _data: i } = this, { iScale: n, _stacked: a } = s, r = n.axis;
    let c = t === 0 && e === i.length ? !0 : s._sorted, h = t > 0 && s._parsed[t - 1], l, d, u;
    if (this._parsing === !1)
      s._parsed = i, s._sorted = !0, u = i;
    else {
      q(i[t]) ? u = this.parseArrayData(s, i, t, e) : I(i[t]) ? u = this.parseObjectData(s, i, t, e) : u = this.parsePrimitiveData(s, i, t, e);
      const f = () => d[r] === null || h && d[r] < h[r];
      for (l = 0; l < e; ++l)
        s._parsed[l + t] = d = u[l], c && (f() && (c = !1), h = d);
      s._sorted = c;
    }
    a && _e(this, u);
  }
  parsePrimitiveData(t, e, s, i) {
    const { iScale: n, vScale: a } = t, r = n.axis, c = a.axis, h = n.getLabels(), l = n === a, d = new Array(i);
    let u, f, g;
    for (u = 0, f = i; u < f; ++u)
      g = u + s, d[u] = {
        [r]: l || n.parse(h[g], g),
        [c]: a.parse(e[g], g)
      };
    return d;
  }
  parseArrayData(t, e, s, i) {
    const { xScale: n, yScale: a } = t, r = new Array(i);
    let c, h, l, d;
    for (c = 0, h = i; c < h; ++c)
      l = c + s, d = e[l], r[c] = {
        x: n.parse(d[0], l),
        y: a.parse(d[1], l)
      };
    return r;
  }
  parseObjectData(t, e, s, i) {
    const { xScale: n, yScale: a } = t, { xAxisKey: r = "x", yAxisKey: c = "y" } = this._parsing, h = new Array(i);
    let l, d, u, f;
    for (l = 0, d = i; l < d; ++l)
      u = l + s, f = e[u], h[l] = {
        x: n.parse(It(f, r), u),
        y: a.parse(It(f, c), u)
      };
    return h;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, s) {
    const i = this.chart, n = this._cachedMeta, a = e[t.axis], r = {
      keys: Je(i, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return pe(r, a, n.index, {
      mode: s
    });
  }
  updateRangeFromParsed(t, e, s, i) {
    const n = s[e.axis];
    let a = n === null ? NaN : n;
    const r = i && s._stacks[e.axis];
    i && r && (i.values = r, a = pe(i, n, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, e) {
    const s = this._cachedMeta, i = s._parsed, n = s._sorted && t === s.iScale, a = i.length, r = this._getOtherScale(t), c = Ks(e, s, this.chart), h = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: l, max: d } = $s(r);
    let u, f;
    function g() {
      f = i[u];
      const m = f[r.axis];
      return !J(f[t.axis]) || l > m || d < m;
    }
    for (u = 0; u < a && !(!g() && (this.updateRangeFromParsed(h, t, f, c), n)); ++u)
      ;
    if (n) {
      for (u = a - 1; u >= 0; --u)
        if (!g()) {
          this.updateRangeFromParsed(h, t, f, c);
          break;
        }
    }
    return h;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, s = [];
    let i, n, a;
    for (i = 0, n = e.length; i < n; ++i)
      a = e[i][t.axis], J(a) && s.push(a);
    return s;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, s = e.iScale, i = e.vScale, n = this.getParsed(t);
    return {
      label: s ? "" + s.getLabelForValue(n[s.axis]) : "",
      value: i ? "" + i.getLabelForValue(n[i.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = Bs(z(this.options.clip, js(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, s = this._cachedMeta, i = s.data || [], n = e.chartArea, a = [], r = this._drawStart || 0, c = this._drawCount || i.length - r, h = this.options.drawActiveElementsOnTop;
    let l;
    for (s.dataset && s.dataset.draw(t, n, r, c), l = r; l < r + c; ++l) {
      const d = i[l];
      d.hidden || (d.active && h ? a.push(d) : d.draw(t, n));
    }
    for (l = 0; l < a.length; ++l)
      a[l].draw(t, n);
  }
  getStyle(t, e) {
    const s = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(s) : this.resolveDataElementOptions(t || 0, s);
  }
  getContext(t, e, s) {
    const i = this.getDataset();
    let n;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      n = a.$context || (a.$context = Xs(this.getContext(), t, a)), n.parsed = this.getParsed(t), n.raw = i.data[t], n.index = n.dataIndex = t;
    } else
      n = this.$context || (this.$context = Ys(this.chart.getContext(), this.index)), n.dataset = i, n.index = n.datasetIndex = this.index;
    return n.active = !!e, n.mode = s, n;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", s) {
    const i = e === "active", n = this._cachedDataOpts, a = t + "-" + e, r = n[a], c = this.enableOptionSharing && Et(s);
    if (r)
      return xe(r, c);
    const h = this.chart.config, l = h.datasetElementScopeKeys(this._type, t), d = i ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], u = h.getOptionScopes(this.getDataset(), l), f = Object.keys(P.elements[t]), g = () => this.getContext(s, i, e), m = h.resolveNamedOptions(u, f, g, d);
    return m.$shared && (m.$shared = c, n[a] = Object.freeze(xe(m, c))), m;
  }
  _resolveAnimations(t, e, s) {
    const i = this.chart, n = this._cachedDataOpts, a = `animation-${e}`, r = n[a];
    if (r)
      return r;
    let c;
    if (i.options.animation !== !1) {
      const l = this.chart.config, d = l.datasetAnimationScopeKeys(this._type, e), u = l.getOptionScopes(this.getDataset(), d);
      c = l.createResolver(u, this.getContext(t, s, e));
    }
    const h = new Fs(i, c && c.animations);
    return c && c._cacheable && (n[a] = Object.freeze(h)), h;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || Ht(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const s = this.resolveDataElementOptions(t, e), i = this._sharedOptions, n = this.getSharedOptions(s), a = this.includeOptions(e, n) || n !== i;
    return this.updateSharedOptions(n, e, s), {
      sharedOptions: n,
      includeOptions: a
    };
  }
  updateElement(t, e, s, i) {
    Ht(i) ? Object.assign(t, s) : this._resolveAnimations(e, i).update(t, s);
  }
  updateSharedOptions(t, e, s) {
    t && !Ht(e) && this._resolveAnimations(void 0, e).update(t, s);
  }
  _setStyle(t, e, s, i) {
    t.active = i;
    const n = this.getStyle(e, i);
    this._resolveAnimations(e, s, i).update(t, {
      options: !i && this.getSharedOptions(n) || n
    });
  }
  removeHoverStyle(t, e, s) {
    this._setStyle(t, s, "active", !1);
  }
  setHoverStyle(t, e, s) {
    this._setStyle(t, s, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, s = this._cachedMeta.data;
    for (const [r, c, h] of this._syncList)
      this[r](c, h);
    this._syncList = [];
    const i = s.length, n = e.length, a = Math.min(n, i);
    a && this.parse(0, a), n > i ? this._insertElements(i, n - i, t) : n < i && this._removeElements(n, i - n);
  }
  _insertElements(t, e, s = !0) {
    const i = this._cachedMeta, n = i.data, a = t + e;
    let r;
    const c = (h) => {
      for (h.length += e, r = h.length - 1; r >= a; r--)
        h[r] = h[r - e];
    };
    for (c(n), r = t; r < a; ++r)
      n[r] = new this.dataElementType();
    this._parsing && c(i._parsed), this.parse(t, e), s && this.updateElements(n, t, e, "reset");
  }
  updateElements(t, e, s, i) {
  }
  _removeElements(t, e) {
    const s = this._cachedMeta;
    if (this._parsing) {
      const i = s._parsed.splice(t, e);
      s._stacked && lt(s, i);
    }
    s.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, s, i] = t;
      this[e](s, i);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const s = arguments.length - 2;
    s && this._sync([
      "_insertElements",
      t,
      s
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
function qs(o, t, e) {
  let s = 1, i = 1, n = 0, a = 0;
  if (t < j) {
    const r = o, c = r + t, h = Math.cos(r), l = Math.sin(r), d = Math.cos(c), u = Math.sin(c), f = (b, v, y) => Pt(b, r, c, !0) ? 1 : Math.max(v, v * e, y, y * e), g = (b, v, y) => Pt(b, r, c, !0) ? -1 : Math.min(v, v * e, y, y * e), m = f(0, h, d), x = f(X, l, u), p = g(H, h, d), _ = g(H + X, l, u);
    s = (m - p) / 2, i = (x - _) / 2, n = -(m + p) / 2, a = -(x + _) / 2;
  }
  return {
    ratioX: s,
    ratioY: i,
    offsetX: n,
    offsetY: a
  };
}
class _n extends Ze {
  static id = "doughnut";
  static defaults = {
    datasetElementType: !1,
    dataElementType: "arc",
    animation: {
      animateRotate: !0,
      animateScale: !1
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "circumference",
          "endAngle",
          "innerRadius",
          "outerRadius",
          "startAngle",
          "x",
          "y",
          "offset",
          "borderWidth",
          "spacing"
        ]
      }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
  };
  static descriptors = {
    _scriptable: (t) => t !== "spacing",
    _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
  };
  static overrides = {
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          generateLabels(t) {
            const e = t.data;
            if (e.labels.length && e.datasets.length) {
              const { labels: { pointStyle: s, color: i } } = t.legend.options;
              return e.labels.map((n, a) => {
                const c = t.getDatasetMeta(0).controller.getStyle(a);
                return {
                  text: n,
                  fillStyle: c.backgroundColor,
                  strokeStyle: c.borderColor,
                  fontColor: i,
                  lineWidth: c.borderWidth,
                  pointStyle: s,
                  hidden: !t.getDataVisibility(a),
                  index: a
                };
              });
            }
            return [];
          }
        },
        onClick(t, e, s) {
          s.chart.toggleDataVisibility(e.index), s.chart.update();
        }
      }
    }
  };
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const s = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = s;
    else {
      let n = (c) => +s[c];
      if (I(s[t])) {
        const { key: c = "value" } = this._parsing;
        n = (h) => +It(s[h], c);
      }
      let a, r;
      for (a = t, r = t + e; a < r; ++a)
        i._parsed[a] = n(a);
    }
  }
  _getRotation() {
    return it(this.options.rotation - 90);
  }
  _getCircumference() {
    return it(this.options.circumference);
  }
  _getRotationExtents() {
    let t = j, e = -j;
    for (let s = 0; s < this.chart.data.datasets.length; ++s)
      if (this.chart.isDatasetVisible(s) && this.chart.getDatasetMeta(s).type === this._type) {
        const i = this.chart.getDatasetMeta(s).controller, n = i._getRotation(), a = i._getCircumference();
        t = Math.min(t, n), e = Math.max(e, n + a);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: s } = e, i = this._cachedMeta, n = i.data, a = this.getMaxBorderWidth() + this.getMaxOffset(n) + this.options.spacing, r = Math.max((Math.min(s.width, s.height) - a) / 2, 0), c = Math.min(fs(this.options.cutout, r), 1), h = this._getRingWeight(this.index), { circumference: l, rotation: d } = this._getRotationExtents(), { ratioX: u, ratioY: f, offsetX: g, offsetY: m } = qs(d, l, c), x = (s.width - a) / u, p = (s.height - a) / f, _ = Math.max(Math.min(x, p) / 2, 0), b = gs(this.options.radius, _), v = Math.max(b * c, 0), y = (b - v) / this._getVisibleDatasetWeightTotal();
    this.offsetX = g * b, this.offsetY = m * b, i.total = this.calculateTotal(), this.outerRadius = b - y * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - y * h, 0), this.updateElements(n, 0, n.length, t);
  }
  _circumference(t, e) {
    const s = this.options, i = this._cachedMeta, n = this._getCircumference();
    return e && s.animation.animateRotate || !this.chart.getDataVisibility(t) || i._parsed[t] === null || i.data[t].hidden ? 0 : this.calculateCircumference(i._parsed[t] * n / j);
  }
  updateElements(t, e, s, i) {
    const n = i === "reset", a = this.chart, r = a.chartArea, h = a.options.animation, l = (r.left + r.right) / 2, d = (r.top + r.bottom) / 2, u = n && h.animateScale, f = u ? 0 : this.innerRadius, g = u ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: x } = this._getSharedOptions(e, i);
    let p = this._getRotation(), _;
    for (_ = 0; _ < e; ++_)
      p += this._circumference(_, n);
    for (_ = e; _ < e + s; ++_) {
      const b = this._circumference(_, n), v = t[_], y = {
        x: l + this.offsetX,
        y: d + this.offsetY,
        startAngle: p,
        endAngle: p + b,
        circumference: b,
        outerRadius: g,
        innerRadius: f
      };
      x && (y.options = m || this.resolveDataElementOptions(_, v.active ? "active" : i)), p += b, this.updateElement(v, _, y, i);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let s = 0, i;
    for (i = 0; i < e.length; i++) {
      const n = t._parsed[i];
      n !== null && !isNaN(n) && this.chart.getDataVisibility(i) && !e[i].hidden && (s += Math.abs(n));
    }
    return s;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? j * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, s = this.chart, i = s.data.labels || [], n = ps(e._parsed[t], s.options.locale);
    return {
      label: i[t] || "",
      value: n
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const s = this.chart;
    let i, n, a, r, c;
    if (!t) {
      for (i = 0, n = s.data.datasets.length; i < n; ++i)
        if (s.isDatasetVisible(i)) {
          a = s.getDatasetMeta(i), t = a.data, r = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (i = 0, n = t.length; i < n; ++i)
      c = r.resolveDataElementOptions(i), c.borderAlign !== "inner" && (e = Math.max(e, c.borderWidth || 0, c.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let s = 0, i = t.length; s < i; ++s) {
      const n = this.resolveDataElementOptions(s);
      e = Math.max(e, n.offset || 0, n.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let s = 0; s < t; ++s)
      this.chart.isDatasetVisible(s) && (e += this._getRingWeight(s));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(z(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
function et() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Jt {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Jt.prototype, t);
  }
  options;
  constructor(t) {
    this.options = t || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return et();
  }
  parse() {
    return et();
  }
  format() {
    return et();
  }
  add() {
    return et();
  }
  diff() {
    return et();
  }
  startOf() {
    return et();
  }
  endOf() {
    return et();
  }
}
var Gs = {
  _date: Jt
};
function Js(o, t, e, s) {
  const { controller: i, data: n, _sorted: a } = o, r = i._cachedMeta.iScale, c = o.dataset && o.dataset.options ? o.dataset.options.spanGaps : null;
  if (r && t === r.axis && t !== "r" && a && n.length) {
    const h = r._reversePixels ? Os : Kt;
    if (s) {
      if (i._sharedOptions) {
        const l = n[0], d = typeof l.getRange == "function" && l.getRange(t);
        if (d) {
          const u = h(n, t, e - d), f = h(n, t, e + d);
          return {
            lo: u.lo,
            hi: f.hi
          };
        }
      }
    } else {
      const l = h(n, t, e);
      if (c) {
        const { vScale: d } = i._cachedMeta, { _parsed: u } = o, f = u.slice(0, l.lo + 1).reverse().findIndex((m) => !$(m[d.axis]));
        l.lo -= Math.max(0, f);
        const g = u.slice(l.hi).findIndex((m) => !$(m[d.axis]));
        l.hi += Math.max(0, g);
      }
      return l;
    }
  }
  return {
    lo: 0,
    hi: n.length - 1
  };
}
function Ft(o, t, e, s, i) {
  const n = o.getSortedVisibleDatasetMetas(), a = e[t];
  for (let r = 0, c = n.length; r < c; ++r) {
    const { index: h, data: l } = n[r], { lo: d, hi: u } = Js(n[r], t, a, i);
    for (let f = d; f <= u; ++f) {
      const g = l[f];
      g.skip || s(g, h, f);
    }
  }
}
function Zs(o) {
  const t = o.indexOf("x") !== -1, e = o.indexOf("y") !== -1;
  return function(s, i) {
    const n = t ? Math.abs(s.x - i.x) : 0, a = e ? Math.abs(s.y - i.y) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(a, 2));
  };
}
function $t(o, t, e, s, i) {
  const n = [];
  return !i && !o.isPointInArea(t) || Ft(o, e, t, function(r, c, h) {
    !i && !Ye(r, o.chartArea, 0) || r.inRange(t.x, t.y, s) && n.push({
      element: r,
      datasetIndex: c,
      index: h
    });
  }, !0), n;
}
function Qs(o, t, e, s) {
  let i = [];
  function n(a, r, c) {
    const { startAngle: h, endAngle: l } = a.getProps([
      "startAngle",
      "endAngle"
    ], s), { angle: d } = Xe(a, {
      x: t.x,
      y: t.y
    });
    Pt(d, h, l) && i.push({
      element: a,
      datasetIndex: r,
      index: c
    });
  }
  return Ft(o, e, t, n), i;
}
function ti(o, t, e, s, i, n) {
  let a = [];
  const r = Zs(e);
  let c = Number.POSITIVE_INFINITY;
  function h(l, d, u) {
    const f = l.inRange(t.x, t.y, i);
    if (s && !f)
      return;
    const g = l.getCenterPoint(i);
    if (!(!!n || o.isPointInArea(g)) && !f)
      return;
    const x = r(t, g);
    x < c ? (a = [
      {
        element: l,
        datasetIndex: d,
        index: u
      }
    ], c = x) : x === c && a.push({
      element: l,
      datasetIndex: d,
      index: u
    });
  }
  return Ft(o, e, t, h), a;
}
function Ut(o, t, e, s, i, n) {
  return !n && !o.isPointInArea(t) ? [] : e === "r" && !s ? Qs(o, t, e, i) : ti(o, t, e, s, i, n);
}
function be(o, t, e, s, i) {
  const n = [], a = e === "x" ? "inXRange" : "inYRange";
  let r = !1;
  return Ft(o, e, t, (c, h, l) => {
    c[a] && c[a](t[e], i) && (n.push({
      element: c,
      datasetIndex: h,
      index: l
    }), r = r || c.inRange(t.x, t.y, i));
  }), s && !r ? [] : n;
}
var ei = {
  modes: {
    index(o, t, e, s) {
      const i = st(t, o), n = e.axis || "x", a = e.includeInvisible || !1, r = e.intersect ? $t(o, i, n, s, a) : Ut(o, i, n, !1, s, a), c = [];
      return r.length ? (o.getSortedVisibleDatasetMetas().forEach((h) => {
        const l = r[0].index, d = h.data[l];
        d && !d.skip && c.push({
          element: d,
          datasetIndex: h.index,
          index: l
        });
      }), c) : [];
    },
    dataset(o, t, e, s) {
      const i = st(t, o), n = e.axis || "xy", a = e.includeInvisible || !1;
      let r = e.intersect ? $t(o, i, n, s, a) : Ut(o, i, n, !1, s, a);
      if (r.length > 0) {
        const c = r[0].datasetIndex, h = o.getDatasetMeta(c).data;
        r = [];
        for (let l = 0; l < h.length; ++l)
          r.push({
            element: h[l],
            datasetIndex: c,
            index: l
          });
      }
      return r;
    },
    point(o, t, e, s) {
      const i = st(t, o), n = e.axis || "xy", a = e.includeInvisible || !1;
      return $t(o, i, n, s, a);
    },
    nearest(o, t, e, s) {
      const i = st(t, o), n = e.axis || "xy", a = e.includeInvisible || !1;
      return Ut(o, i, n, e.intersect, s, a);
    },
    x(o, t, e, s) {
      const i = st(t, o);
      return be(o, i, "x", e.intersect, s);
    },
    y(o, t, e, s) {
      const i = st(t, o);
      return be(o, i, "y", e.intersect, s);
    }
  }
};
const Qe = [
  "left",
  "top",
  "right",
  "bottom"
];
function dt(o, t) {
  return o.filter((e) => e.pos === t);
}
function ye(o, t) {
  return o.filter((e) => Qe.indexOf(e.pos) === -1 && e.box.axis === t);
}
function ut(o, t) {
  return o.sort((e, s) => {
    const i = t ? s : e, n = t ? e : s;
    return i.weight === n.weight ? i.index - n.index : i.weight - n.weight;
  });
}
function si(o) {
  const t = [];
  let e, s, i, n, a, r;
  for (e = 0, s = (o || []).length; e < s; ++e)
    i = o[e], { position: n, options: { stack: a, stackWeight: r = 1 } } = i, t.push({
      index: e,
      box: i,
      pos: n,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: a && n + a,
      stackWeight: r
    });
  return t;
}
function ii(o) {
  const t = {};
  for (const e of o) {
    const { stack: s, pos: i, stackWeight: n } = e;
    if (!s || !Qe.includes(i))
      continue;
    const a = t[s] || (t[s] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += n;
  }
  return t;
}
function ni(o, t) {
  const e = ii(o), { vBoxMaxWidth: s, hBoxMaxHeight: i } = t;
  let n, a, r;
  for (n = 0, a = o.length; n < a; ++n) {
    r = o[n];
    const { fullSize: c } = r.box, h = e[r.stack], l = h && r.stackWeight / h.weight;
    r.horizontal ? (r.width = l ? l * s : c && t.availableWidth, r.height = i) : (r.width = s, r.height = l ? l * i : c && t.availableHeight);
  }
  return e;
}
function oi(o) {
  const t = si(o), e = ut(t.filter((h) => h.box.fullSize), !0), s = ut(dt(t, "left"), !0), i = ut(dt(t, "right")), n = ut(dt(t, "top"), !0), a = ut(dt(t, "bottom")), r = ye(t, "x"), c = ye(t, "y");
  return {
    fullSize: e,
    leftAndTop: s.concat(n),
    rightAndBottom: i.concat(c).concat(a).concat(r),
    chartArea: dt(t, "chartArea"),
    vertical: s.concat(i).concat(c),
    horizontal: n.concat(a).concat(r)
  };
}
function ve(o, t, e, s) {
  return Math.max(o[e], t[e]) + Math.max(o[s], t[s]);
}
function ts(o, t) {
  o.top = Math.max(o.top, t.top), o.left = Math.max(o.left, t.left), o.bottom = Math.max(o.bottom, t.bottom), o.right = Math.max(o.right, t.right);
}
function ai(o, t, e, s) {
  const { pos: i, box: n } = e, a = o.maxPadding;
  if (!I(i)) {
    e.size && (o[i] -= e.size);
    const d = s[e.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, e.horizontal ? n.height : n.width), e.size = d.size / d.count, o[i] += e.size;
  }
  n.getPadding && ts(a, n.getPadding());
  const r = Math.max(0, t.outerWidth - ve(a, o, "left", "right")), c = Math.max(0, t.outerHeight - ve(a, o, "top", "bottom")), h = r !== o.w, l = c !== o.h;
  return o.w = r, o.h = c, e.horizontal ? {
    same: h,
    other: l
  } : {
    same: l,
    other: h
  };
}
function ri(o) {
  const t = o.maxPadding;
  function e(s) {
    const i = Math.max(t[s] - o[s], 0);
    return o[s] += i, i;
  }
  o.y += e("top"), o.x += e("left"), e("right"), e("bottom");
}
function ci(o, t) {
  const e = t.maxPadding;
  function s(i) {
    const n = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return i.forEach((a) => {
      n[a] = Math.max(t[a], e[a]);
    }), n;
  }
  return s(o ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function pt(o, t, e, s) {
  const i = [];
  let n, a, r, c, h, l;
  for (n = 0, a = o.length, h = 0; n < a; ++n) {
    r = o[n], c = r.box, c.update(r.width || t.w, r.height || t.h, ci(r.horizontal, t));
    const { same: d, other: u } = ai(t, e, r, s);
    h |= d && i.length, l = l || u, c.fullSize || i.push(r);
  }
  return h && pt(i, t, e, s) || l;
}
function vt(o, t, e, s, i) {
  o.top = e, o.left = t, o.right = t + s, o.bottom = e + i, o.width = s, o.height = i;
}
function ke(o, t, e, s) {
  const i = e.padding;
  let { x: n, y: a } = t;
  for (const r of o) {
    const c = r.box, h = s[r.stack] || {
      placed: 0,
      weight: 1
    }, l = r.stackWeight / h.weight || 1;
    if (r.horizontal) {
      const d = t.w * l, u = h.size || c.height;
      Et(h.start) && (a = h.start), c.fullSize ? vt(c, i.left, a, e.outerWidth - i.right - i.left, u) : vt(c, t.left + h.placed, a, d, u), h.start = a, h.placed += d, a = c.bottom;
    } else {
      const d = t.h * l, u = h.size || c.width;
      Et(h.start) && (n = h.start), c.fullSize ? vt(c, n, i.top, u, e.outerHeight - i.bottom - i.top) : vt(c, n, t.top + h.placed, u, d), h.start = n, h.placed += d, n = c.right;
    }
  }
  t.x = n, t.y = a;
}
var kt = {
  addBox(o, t) {
    o.boxes || (o.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, o.boxes.push(t);
  },
  removeBox(o, t) {
    const e = o.boxes ? o.boxes.indexOf(t) : -1;
    e !== -1 && o.boxes.splice(e, 1);
  },
  configure(o, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(o, t, e, s) {
    if (!o)
      return;
    const i = mt(o.options.layout.padding), n = Math.max(t - i.width, 0), a = Math.max(e - i.height, 0), r = oi(o.boxes), c = r.vertical, h = r.horizontal;
    T(o.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const l = c.reduce((m, x) => x.box.options && x.box.options.display === !1 ? m : m + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: i,
      availableWidth: n,
      availableHeight: a,
      vBoxMaxWidth: n / 2 / l,
      hBoxMaxHeight: a / 2
    }), u = Object.assign({}, i);
    ts(u, mt(s));
    const f = Object.assign({
      maxPadding: u,
      w: n,
      h: a,
      x: i.left,
      y: i.top
    }, i), g = ni(c.concat(h), d);
    pt(r.fullSize, f, d, g), pt(c, f, d, g), pt(h, f, d, g) && pt(c, f, d, g), ri(f), ke(r.leftAndTop, f, d, g), f.x += f.w, f.y += f.h, ke(r.rightAndBottom, f, d, g), o.chartArea = {
      left: f.left,
      top: f.top,
      right: f.left + f.w,
      bottom: f.top + f.h,
      height: f.h,
      width: f.w
    }, T(r.chartArea, (m) => {
      const x = m.box;
      Object.assign(x, o.chartArea), x.update(f.w, f.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class es {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, s) {
  }
  removeEventListener(t, e, s) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, s, i) {
    return e = Math.max(0, e || t.width), s = s || t.height, {
      width: e,
      height: Math.max(0, i ? Math.floor(e / i) : s)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class hi extends es {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const At = "$chartjs", li = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Me = (o) => o === null || o === "";
function di(o, t) {
  const e = o.style, s = o.getAttribute("height"), i = o.getAttribute("width");
  if (o[At] = {
    initial: {
      height: s,
      width: i,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", Me(i)) {
    const n = he(o, "width");
    n !== void 0 && (o.width = n);
  }
  if (Me(s))
    if (o.style.height === "")
      o.height = o.width / (t || 2);
    else {
      const n = he(o, "height");
      n !== void 0 && (o.height = n);
    }
  return o;
}
const ss = Cs ? {
  passive: !0
} : !1;
function ui(o, t, e) {
  o && o.addEventListener(t, e, ss);
}
function fi(o, t, e) {
  o && o.canvas && o.canvas.removeEventListener(t, e, ss);
}
function gi(o, t) {
  const e = li[o.type] || o.type, { x: s, y: i } = st(o, t);
  return {
    type: e,
    chart: t,
    native: o,
    x: s !== void 0 ? s : null,
    y: i !== void 0 ? i : null
  };
}
function Rt(o, t) {
  for (const e of o)
    if (e === t || e.contains(t))
      return !0;
}
function pi(o, t, e) {
  const s = o.canvas, i = new MutationObserver((n) => {
    let a = !1;
    for (const r of n)
      a = a || Rt(r.addedNodes, s), a = a && !Rt(r.removedNodes, s);
    a && e();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
function mi(o, t, e) {
  const s = o.canvas, i = new MutationObserver((n) => {
    let a = !1;
    for (const r of n)
      a = a || Rt(r.removedNodes, s), a = a && !Rt(r.addedNodes, s);
    a && e();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
const _t = /* @__PURE__ */ new Map();
let we = 0;
function is() {
  const o = window.devicePixelRatio;
  o !== we && (we = o, _t.forEach((t, e) => {
    e.currentDevicePixelRatio !== o && t();
  }));
}
function _i(o, t) {
  _t.size || window.addEventListener("resize", is), _t.set(o, t);
}
function xi(o) {
  _t.delete(o), _t.size || window.removeEventListener("resize", is);
}
function bi(o, t, e) {
  const s = o.canvas, i = s && qe(s);
  if (!i)
    return;
  const n = Ge((r, c) => {
    const h = i.clientWidth;
    e(r, c), h < i.clientWidth && e();
  }, window), a = new ResizeObserver((r) => {
    const c = r[0], h = c.contentRect.width, l = c.contentRect.height;
    h === 0 && l === 0 || n(h, l);
  });
  return a.observe(i), _i(o, n), a;
}
function Yt(o, t, e) {
  e && e.disconnect(), t === "resize" && xi(o);
}
function yi(o, t, e) {
  const s = o.canvas, i = Ge((n) => {
    o.ctx !== null && e(gi(n, o));
  }, o);
  return ui(s, t, i), i;
}
class vi extends es {
  acquireContext(t, e) {
    const s = t && t.getContext && t.getContext("2d");
    return s && s.canvas === t ? (di(t, e), s) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[At])
      return !1;
    const s = e[At].initial;
    [
      "height",
      "width"
    ].forEach((n) => {
      const a = s[n];
      $(a) ? e.removeAttribute(n) : e.setAttribute(n, a);
    });
    const i = s.style || {};
    return Object.keys(i).forEach((n) => {
      e.style[n] = i[n];
    }), e.width = e.width, delete e[At], !0;
  }
  addEventListener(t, e, s) {
    this.removeEventListener(t, e);
    const i = t.$proxies || (t.$proxies = {}), a = {
      attach: pi,
      detach: mi,
      resize: bi
    }[e] || yi;
    i[e] = a(t, e, s);
  }
  removeEventListener(t, e) {
    const s = t.$proxies || (t.$proxies = {}), i = s[e];
    if (!i)
      return;
    ({
      attach: Yt,
      detach: Yt,
      resize: Yt
    }[e] || fi)(t, e, i), s[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, s, i) {
    return ws(t, e, s, i);
  }
  isAttached(t) {
    const e = t && qe(t);
    return !!(e && e.isConnected);
  }
}
function ki(o) {
  return !Ke() || typeof OffscreenCanvas < "u" && o instanceof OffscreenCanvas ? hi : vi;
}
class Zt {
  static defaults = {};
  static defaultRoutes = void 0;
  x;
  y;
  active = !1;
  options;
  $animations;
  tooltipPosition(t) {
    const { x: e, y: s } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: s
    };
  }
  hasValue() {
    return Lt(this.x) && Lt(this.y);
  }
  getProps(t, e) {
    const s = this.$animations;
    if (!e || !s)
      return this;
    const i = {};
    return t.forEach((n) => {
      i[n] = s[n] && s[n].active() ? s[n]._to : this[n];
    }), i;
  }
}
function Mi(o, t) {
  const e = o.options.ticks, s = wi(o), i = Math.min(e.maxTicksLimit || s, s), n = e.major.enabled ? Di(t) : [], a = n.length, r = n[0], c = n[a - 1], h = [];
  if (a > i)
    return Oi(t, h, n, a / i), h;
  const l = Si(n, t, i);
  if (a > 0) {
    let d, u;
    const f = a > 1 ? Math.round((c - r) / (a - 1)) : null;
    for (Mt(t, h, l, $(f) ? 0 : r - f, r), d = 0, u = a - 1; d < u; d++)
      Mt(t, h, l, n[d], n[d + 1]);
    return Mt(t, h, l, c, $(f) ? t.length : c + f), h;
  }
  return Mt(t, h, l), h;
}
function wi(o) {
  const t = o.options.offset, e = o._tickSize(), s = o._length / e + (t ? 0 : 1), i = o._maxLength / e;
  return Math.floor(Math.min(s, i));
}
function Si(o, t, e) {
  const s = Ai(o), i = t.length / e;
  if (!s)
    return Math.max(i, 1);
  const n = Ds(s);
  for (let a = 0, r = n.length - 1; a < r; a++) {
    const c = n[a];
    if (c > i)
      return c;
  }
  return Math.max(i, 1);
}
function Di(o) {
  const t = [];
  let e, s;
  for (e = 0, s = o.length; e < s; e++)
    o[e].major && t.push(e);
  return t;
}
function Oi(o, t, e, s) {
  let i = 0, n = e[0], a;
  for (s = Math.ceil(s), a = 0; a < o.length; a++)
    a === n && (t.push(o[a]), i++, n = e[i * s]);
}
function Mt(o, t, e, s, i) {
  const n = z(s, 0), a = Math.min(z(i, o.length), o.length);
  let r = 0, c, h, l;
  for (e = Math.ceil(e), i && (c = i - s, e = c / Math.floor(c / e)), l = n; l < 0; )
    r++, l = Math.round(n + r * e);
  for (h = Math.max(n, 0); h < a; h++)
    h === l && (t.push(o[h]), r++, l = Math.round(n + r * e));
}
function Ai(o) {
  const t = o.length;
  let e, s;
  if (t < 2)
    return !1;
  for (s = o[0], e = 1; e < t; ++e)
    if (o[e] - o[e - 1] !== s)
      return !1;
  return s;
}
const Ci = (o) => o === "left" ? "right" : o === "right" ? "left" : o, Se = (o, t, e) => t === "top" || t === "left" ? o[t] + e : o[t] - e, De = (o, t) => Math.min(t || o, o);
function Oe(o, t) {
  const e = [], s = o.length / t, i = o.length;
  let n = 0;
  for (; n < i; n += s)
    e.push(o[Math.floor(n)]);
  return e;
}
function Ei(o, t, e) {
  const s = o.ticks.length, i = Math.min(t, s - 1), n = o._startPixel, a = o._endPixel, r = 1e-6;
  let c = o.getPixelForTick(i), h;
  if (!(e && (s === 1 ? h = Math.max(c - n, a - c) : t === 0 ? h = (o.getPixelForTick(1) - c) / 2 : h = (c - o.getPixelForTick(i - 1)) / 2, c += i < t ? h : -h, c < n - r || c > a + r)))
    return c;
}
function Pi(o, t) {
  T(o, (e) => {
    const s = e.gc, i = s.length / 2;
    let n;
    if (i > t) {
      for (n = 0; n < i; ++n)
        delete e.data[s[n]];
      s.splice(0, i);
    }
  });
}
function ft(o) {
  return o.drawTicks ? o.tickLength : 0;
}
function Ae(o, t) {
  if (!o.display)
    return 0;
  const e = Xt(o.font, t), s = mt(o.padding);
  return (q(o.text) ? o.text.length : 1) * e.lineHeight + s.height;
}
function Li(o, t) {
  return xt(o, {
    scale: t,
    type: "scale"
  });
}
function Ii(o, t, e) {
  return xt(o, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function Ri(o, t, e) {
  let s = Es(o);
  return (e && t !== "right" || !e && t === "right") && (s = Ci(s)), s;
}
function Ti(o, t, e, s) {
  const { top: i, left: n, bottom: a, right: r, chart: c } = o, { chartArea: h, scales: l } = c;
  let d = 0, u, f, g;
  const m = a - i, x = r - n;
  if (o.isHorizontal()) {
    if (f = ue(s, n, r), I(e)) {
      const p = Object.keys(e)[0], _ = e[p];
      g = l[p].getPixelForValue(_) + m - t;
    } else e === "center" ? g = (h.bottom + h.top) / 2 + m - t : g = Se(o, e, t);
    u = r - n;
  } else {
    if (I(e)) {
      const p = Object.keys(e)[0], _ = e[p];
      f = l[p].getPixelForValue(_) - x + t;
    } else e === "center" ? f = (h.left + h.right) / 2 - x + t : f = Se(o, e, t);
    g = ue(s, a, i), d = e === "left" ? -X : X;
  }
  return {
    titleX: f,
    titleY: g,
    maxWidth: u,
    rotation: d
  };
}
class Vt extends Zt {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: s, _suggestedMax: i } = this;
    return t = U(t, Number.POSITIVE_INFINITY), e = U(e, Number.NEGATIVE_INFINITY), s = U(s, Number.POSITIVE_INFINITY), i = U(i, Number.NEGATIVE_INFINITY), {
      min: U(t, s),
      max: U(e, i),
      minDefined: J(t),
      maxDefined: J(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: s, minDefined: i, maxDefined: n } = this.getUserBounds(), a;
    if (i && n)
      return {
        min: e,
        max: s
      };
    const r = this.getMatchingVisibleMetas();
    for (let c = 0, h = r.length; c < h; ++c)
      a = r[c].controller.getMinMax(this, t), i || (e = Math.min(e, a.min)), n || (s = Math.max(s, a.max));
    return e = n && e > s ? s : e, s = i && e > s ? e : s, {
      min: U(e, U(s, e)),
      max: U(s, U(e, s))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    A(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, s) {
    const { beginAtZero: i, grace: n, ticks: a } = this.options, r = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = s = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, s), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + s.left + s.right : this.height + s.top + s.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = bs(this, n, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const c = r < this.ticks.length;
    this._convertTicksToLabels(c ? Oe(this.ticks, r) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = Mi(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), c && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, s;
    this.isHorizontal() ? (e = this.left, s = this.right) : (e = this.top, s = this.bottom, t = !t), this._startPixel = e, this._endPixel = s, this._reversePixels = t, this._length = s - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    A(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    A(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    A(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), A(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    A(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let s, i, n;
    for (s = 0, i = t.length; s < i; s++)
      n = t[s], n.label = A(e.callback, [
        n.value,
        s,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    A(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    A(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, s = De(this.ticks.length, t.ticks.maxTicksLimit), i = e.minRotation || 0, n = e.maxRotation;
    let a = i, r, c, h;
    if (!this._isVisible() || !e.display || i >= n || s <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const l = this._getLabelSizes(), d = l.widest.width, u = l.highest.height, f = G(this.chart.width - d, 0, this.maxWidth);
    r = t.offset ? this.maxWidth / s : f / (s - 1), d + 6 > r && (r = f / (s - (t.offset ? 0.5 : 1)), c = this.maxHeight - ft(t.grid) - e.padding - Ae(t.title, this.chart.options.font), h = Math.sqrt(d * d + u * u), a = ys(Math.min(Math.asin(G((l.highest.height + 6) / r, -1, 1)), Math.asin(G(c / h, -1, 1)) - Math.asin(G(u / h, -1, 1)))), a = Math.max(i, Math.min(n, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    A(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    A(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: s, title: i, grid: n } } = this, a = this._isVisible(), r = this.isHorizontal();
    if (a) {
      const c = Ae(i, e.options.font);
      if (r ? (t.width = this.maxWidth, t.height = ft(n) + c) : (t.height = this.maxHeight, t.width = ft(n) + c), s.display && this.ticks.length) {
        const { first: h, last: l, widest: d, highest: u } = this._getLabelSizes(), f = s.padding * 2, g = it(this.labelRotation), m = Math.cos(g), x = Math.sin(g);
        if (r) {
          const p = s.mirror ? 0 : x * d.width + m * u.height;
          t.height = Math.min(this.maxHeight, t.height + p + f);
        } else {
          const p = s.mirror ? 0 : m * d.width + x * u.height;
          t.width = Math.min(this.maxWidth, t.width + p + f);
        }
        this._calculatePadding(h, l, x, m);
      }
    }
    this._handleMargins(), r ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, s, i) {
    const { ticks: { align: n, padding: a }, position: r } = this.options, c = this.labelRotation !== 0, h = r !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const l = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let u = 0, f = 0;
      c ? h ? (u = i * t.width, f = s * e.height) : (u = s * t.height, f = i * e.width) : n === "start" ? f = e.width : n === "end" ? u = t.width : n !== "inner" && (u = t.width / 2, f = e.width / 2), this.paddingLeft = Math.max((u - l + a) * this.width / (this.width - l), 0), this.paddingRight = Math.max((f - d + a) * this.width / (this.width - d), 0);
    } else {
      let l = e.height / 2, d = t.height / 2;
      n === "start" ? (l = 0, d = t.height) : n === "end" && (l = e.height, d = 0), this.paddingTop = l + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    A(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, s;
    for (e = 0, s = t.length; e < s; e++)
      $(t[e].label) && (t.splice(e, 1), s--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let s = this.ticks;
      e < s.length && (s = Oe(s, e)), this._labelSizes = t = this._computeLabelSizes(s, s.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, s) {
    const { ctx: i, _longestTextCache: n } = this, a = [], r = [], c = Math.floor(e / De(e, s));
    let h = 0, l = 0, d, u, f, g, m, x, p, _, b, v, y;
    for (d = 0; d < e; d += c) {
      if (g = t[d].label, m = this._resolveTickFontOptions(d), i.font = x = m.string, p = n[x] = n[x] || {
        data: {},
        gc: []
      }, _ = m.lineHeight, b = v = 0, !$(g) && !q(g))
        b = ae(i, p.data, p.gc, b, g), v = _;
      else if (q(g))
        for (u = 0, f = g.length; u < f; ++u)
          y = g[u], !$(y) && !q(y) && (b = ae(i, p.data, p.gc, b, y), v += _);
      a.push(b), r.push(v), h = Math.max(b, h), l = Math.max(v, l);
    }
    Pi(n, e);
    const S = a.indexOf(h), D = r.indexOf(l), L = (E) => ({
      width: a[E] || 0,
      height: r[E] || 0
    });
    return {
      first: L(0),
      last: L(e - 1),
      widest: L(S),
      highest: L(D),
      widths: a,
      heights: r
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return vs(this._alignToPixels ? tt(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const s = e[t];
      return s.$context || (s.$context = Ii(this.getContext(), t, s));
    }
    return this.$context || (this.$context = Li(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = it(this.labelRotation), s = Math.abs(Math.cos(e)), i = Math.abs(Math.sin(e)), n = this._getLabelSizes(), a = t.autoSkipPadding || 0, r = n ? n.widest.width + a : 0, c = n ? n.highest.height + a : 0;
    return this.isHorizontal() ? c * s > r * i ? r / s : c / i : c * i < r * s ? c / s : r / i;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, s = this.chart, i = this.options, { grid: n, position: a, border: r } = i, c = n.offset, h = this.isHorizontal(), d = this.ticks.length + (c ? 1 : 0), u = ft(n), f = [], g = r.setContext(this.getContext()), m = g.display ? g.width : 0, x = m / 2, p = function(w) {
      return tt(s, w, m);
    };
    let _, b, v, y, S, D, L, E, M, F, C, N;
    if (a === "top")
      _ = p(this.bottom), D = this.bottom - u, E = _ - x, F = p(t.top) + x, N = t.bottom;
    else if (a === "bottom")
      _ = p(this.top), F = t.top, N = p(t.bottom) - x, D = _ + x, E = this.top + u;
    else if (a === "left")
      _ = p(this.right), S = this.right - u, L = _ - x, M = p(t.left) + x, C = t.right;
    else if (a === "right")
      _ = p(this.left), M = t.left, C = p(t.right) - x, S = _ + x, L = this.left + u;
    else if (e === "x") {
      if (a === "center")
        _ = p((t.top + t.bottom) / 2 + 0.5);
      else if (I(a)) {
        const w = Object.keys(a)[0], O = a[w];
        _ = p(this.chart.scales[w].getPixelForValue(O));
      }
      F = t.top, N = t.bottom, D = _ + x, E = D + u;
    } else if (e === "y") {
      if (a === "center")
        _ = p((t.left + t.right) / 2);
      else if (I(a)) {
        const w = Object.keys(a)[0], O = a[w];
        _ = p(this.chart.scales[w].getPixelForValue(O));
      }
      S = _ - x, L = S - u, M = t.left, C = t.right;
    }
    const B = z(i.ticks.maxTicksLimit, d), k = Math.max(1, Math.ceil(d / B));
    for (b = 0; b < d; b += k) {
      const w = this.getContext(b), O = n.setContext(w), W = r.setContext(w), R = O.lineWidth, nt = O.color, bt = W.dash || [], ot = W.dashOffset, ct = O.tickWidth, Z = O.tickColor, ht = O.tickBorderDash || [], Q = O.tickBorderDashOffset;
      v = Ei(this, b, c), v !== void 0 && (y = tt(s, v, R), h ? S = L = M = C = y : D = E = F = N = y, f.push({
        tx1: S,
        ty1: D,
        tx2: L,
        ty2: E,
        x1: M,
        y1: F,
        x2: C,
        y2: N,
        width: R,
        color: nt,
        borderDash: bt,
        borderDashOffset: ot,
        tickWidth: ct,
        tickColor: Z,
        tickBorderDash: ht,
        tickBorderDashOffset: Q
      }));
    }
    return this._ticksLength = d, this._borderValue = _, f;
  }
  _computeLabelItems(t) {
    const e = this.axis, s = this.options, { position: i, ticks: n } = s, a = this.isHorizontal(), r = this.ticks, { align: c, crossAlign: h, padding: l, mirror: d } = n, u = ft(s.grid), f = u + l, g = d ? -l : f, m = -it(this.labelRotation), x = [];
    let p, _, b, v, y, S, D, L, E, M, F, C, N = "middle";
    if (i === "top")
      S = this.bottom - g, D = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      S = this.top + g, D = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const k = this._getYAxisLabelAlignment(u);
      D = k.textAlign, y = k.x;
    } else if (i === "right") {
      const k = this._getYAxisLabelAlignment(u);
      D = k.textAlign, y = k.x;
    } else if (e === "x") {
      if (i === "center")
        S = (t.top + t.bottom) / 2 + f;
      else if (I(i)) {
        const k = Object.keys(i)[0], w = i[k];
        S = this.chart.scales[k].getPixelForValue(w) + f;
      }
      D = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (i === "center")
        y = (t.left + t.right) / 2 - f;
      else if (I(i)) {
        const k = Object.keys(i)[0], w = i[k];
        y = this.chart.scales[k].getPixelForValue(w);
      }
      D = this._getYAxisLabelAlignment(u).textAlign;
    }
    e === "y" && (c === "start" ? N = "top" : c === "end" && (N = "bottom"));
    const B = this._getLabelSizes();
    for (p = 0, _ = r.length; p < _; ++p) {
      b = r[p], v = b.label;
      const k = n.setContext(this.getContext(p));
      L = this.getPixelForTick(p) + n.labelOffset, E = this._resolveTickFontOptions(p), M = E.lineHeight, F = q(v) ? v.length : 1;
      const w = F / 2, O = k.color, W = k.textStrokeColor, R = k.textStrokeWidth;
      let nt = D;
      a ? (y = L, D === "inner" && (p === _ - 1 ? nt = this.options.reverse ? "left" : "right" : p === 0 ? nt = this.options.reverse ? "right" : "left" : nt = "center"), i === "top" ? h === "near" || m !== 0 ? C = -F * M + M / 2 : h === "center" ? C = -B.highest.height / 2 - w * M + M : C = -B.highest.height + M / 2 : h === "near" || m !== 0 ? C = M / 2 : h === "center" ? C = B.highest.height / 2 - w * M : C = B.highest.height - F * M, d && (C *= -1), m !== 0 && !k.showLabelBackdrop && (y += M / 2 * Math.sin(m))) : (S = L, C = (1 - F) * M / 2);
      let bt;
      if (k.showLabelBackdrop) {
        const ot = mt(k.backdropPadding), ct = B.heights[p], Z = B.widths[p];
        let ht = C - ot.top, Q = 0 - ot.left;
        switch (N) {
          case "middle":
            ht -= ct / 2;
            break;
          case "bottom":
            ht -= ct;
            break;
        }
        switch (D) {
          case "center":
            Q -= Z / 2;
            break;
          case "right":
            Q -= Z;
            break;
          case "inner":
            p === _ - 1 ? Q -= Z : p > 0 && (Q -= Z / 2);
            break;
        }
        bt = {
          left: Q,
          top: ht,
          width: Z + ot.width,
          height: ct + ot.height,
          color: k.backdropColor
        };
      }
      x.push({
        label: v,
        font: E,
        textOffset: C,
        options: {
          rotation: m,
          color: O,
          strokeColor: W,
          strokeWidth: R,
          textAlign: nt,
          textBaseline: N,
          translation: [
            y,
            S
          ],
          backdrop: bt
        }
      });
    }
    return x;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-it(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return e.align === "start" ? i = "left" : e.align === "end" ? i = "right" : e.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: s, mirror: i, padding: n } } = this.options, a = this._getLabelSizes(), r = t + n, c = a.widest.width;
    let h, l;
    return e === "left" ? i ? (l = this.right + n, s === "near" ? h = "left" : s === "center" ? (h = "center", l += c / 2) : (h = "right", l += c)) : (l = this.right - r, s === "near" ? h = "right" : s === "center" ? (h = "center", l -= c / 2) : (h = "left", l = this.left)) : e === "right" ? i ? (l = this.left + n, s === "near" ? h = "right" : s === "center" ? (h = "center", l -= c / 2) : (h = "left", l -= c)) : (l = this.left + r, s === "near" ? h = "left" : s === "center" ? (h = "center", l += c / 2) : (h = "right", l = this.right)) : h = "right", {
      textAlign: h,
      x: l
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: s, top: i, width: n, height: a } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(s, i, n, a), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const i = this.ticks.findIndex((n) => n.value === t);
    return i >= 0 ? e.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, s = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let n, a;
    const r = (c, h, l) => {
      !l.width || !l.color || (s.save(), s.lineWidth = l.width, s.strokeStyle = l.color, s.setLineDash(l.borderDash || []), s.lineDashOffset = l.borderDashOffset, s.beginPath(), s.moveTo(c.x, c.y), s.lineTo(h.x, h.y), s.stroke(), s.restore());
    };
    if (e.display)
      for (n = 0, a = i.length; n < a; ++n) {
        const c = i[n];
        e.drawOnChartArea && r({
          x: c.x1,
          y: c.y1
        }, {
          x: c.x2,
          y: c.y2
        }, c), e.drawTicks && r({
          x: c.tx1,
          y: c.ty1
        }, {
          x: c.tx2,
          y: c.ty2
        }, {
          color: c.tickColor,
          width: c.tickWidth,
          borderDash: c.tickBorderDash,
          borderDashOffset: c.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: s, grid: i } } = this, n = s.setContext(this.getContext()), a = s.display ? n.width : 0;
    if (!a)
      return;
    const r = i.setContext(this.getContext(0)).lineWidth, c = this._borderValue;
    let h, l, d, u;
    this.isHorizontal() ? (h = tt(t, this.left, a) - a / 2, l = tt(t, this.right, r) + r / 2, d = u = c) : (d = tt(t, this.top, a) - a / 2, u = tt(t, this.bottom, r) + r / 2, h = l = c), e.save(), e.lineWidth = n.width, e.strokeStyle = n.color, e.beginPath(), e.moveTo(h, d), e.lineTo(l, u), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const s = this.ctx, i = this._computeLabelArea();
    i && $e(s, i);
    const n = this.getLabelItems(t);
    for (const a of n) {
      const r = a.options, c = a.font, h = a.label, l = a.textOffset;
      re(s, h, 0, l, c, r);
    }
    i && Ue(s);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: s, reverse: i } } = this;
    if (!s.display)
      return;
    const n = Xt(s.font), a = mt(s.padding), r = s.align;
    let c = n.lineHeight / 2;
    e === "bottom" || e === "center" || I(e) ? (c += a.bottom, q(s.text) && (c += n.lineHeight * (s.text.length - 1))) : c += a.top;
    const { titleX: h, titleY: l, maxWidth: d, rotation: u } = Ti(this, c, e, r);
    re(t, s.text, 0, 0, n, {
      color: s.color,
      maxWidth: d,
      rotation: u,
      textAlign: Ri(r, e, i),
      textBaseline: "middle",
      translation: [
        h,
        l
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, s = z(t.grid && t.grid.z, -1), i = z(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Vt.prototype.draw ? [
      {
        z: e,
        draw: (n) => {
          this.draw(n);
        }
      }
    ] : [
      {
        z: s,
        draw: (n) => {
          this.drawBackground(), this.drawGrid(n), this.drawTitle();
        }
      },
      {
        z: i,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (n) => {
          this.drawLabels(n);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), s = this.axis + "AxisID", i = [];
    let n, a;
    for (n = 0, a = e.length; n < a; ++n) {
      const r = e[n];
      r[s] === this.id && (!t || r.type === t) && i.push(r);
    }
    return i;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return Xt(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class wt {
  constructor(t, e, s) {
    this.type = t, this.scope = e, this.override = s, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let s;
    Vi(e) && (s = this.register(e));
    const i = this.items, n = t.id, a = this.scope + "." + n;
    if (!n)
      throw new Error("class does not have id: " + t);
    return n in i || (i[n] = t, zi(t, a, s), this.override && P.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, s = t.id, i = this.scope;
    s in e && delete e[s], i && s in P[i] && (delete P[i][s], this.override && delete rt[s]);
  }
}
function zi(o, t, e) {
  const s = Ss(/* @__PURE__ */ Object.create(null), [
    e ? P.get(e) : {},
    P.get(t),
    o.defaults
  ]);
  P.set(t, s), o.defaultRoutes && Fi(t, o.defaultRoutes), o.descriptors && P.describe(t, o.descriptors);
}
function Fi(o, t) {
  Object.keys(t).forEach((e) => {
    const s = e.split("."), i = s.pop(), n = [
      o
    ].concat(s).join("."), a = t[e].split("."), r = a.pop(), c = a.join(".");
    P.route(n, i, c, r);
  });
}
function Vi(o) {
  return "id" in o && "defaults" in o;
}
class Ni {
  constructor() {
    this.controllers = new wt(Ze, "datasets", !0), this.elements = new wt(Zt, "elements"), this.plugins = new wt(Object, "plugins"), this.scales = new wt(Vt, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, s) {
    [
      ...e
    ].forEach((i) => {
      const n = s || this._getRegistryForType(i);
      s || n.isForType(i) || n === this.plugins && i.id ? this._exec(t, n, i) : T(i, (a) => {
        const r = s || this._getRegistryForType(a);
        this._exec(t, r, a);
      });
    });
  }
  _exec(t, e, s) {
    const i = ms(t);
    A(s["before" + i], [], s), e[t](s), A(s["after" + i], [], s);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const s = this._typedRegistries[e];
      if (s.isForType(t))
        return s;
    }
    return this.plugins;
  }
  _get(t, e, s) {
    const i = e.get(t);
    if (i === void 0)
      throw new Error('"' + t + '" is not a registered ' + s + ".");
    return i;
  }
}
var Y = /* @__PURE__ */ new Ni();
class ji {
  constructor() {
    this._init = [];
  }
  notify(t, e, s, i) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const n = i ? this._descriptors(t).filter(i) : this._descriptors(t), a = this._notify(n, t, e, s);
    return e === "afterDestroy" && (this._notify(n, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, e, s, i) {
    i = i || {};
    for (const n of t) {
      const a = n.plugin, r = a[s], c = [
        e,
        i,
        n.options
      ];
      if (A(r, c, a) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    $(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const s = t && t.config, i = z(s.options && s.options.plugins, {}), n = Bi(s);
    return i === !1 && !e ? [] : Hi(t, n, i, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], s = this._cache, i = (n, a) => n.filter((r) => !a.some((c) => r.plugin.id === c.plugin.id));
    this._notify(i(e, s), t, "stop"), this._notify(i(s, e), t, "start");
  }
}
function Bi(o) {
  const t = {}, e = [], s = Object.keys(Y.plugins.items);
  for (let n = 0; n < s.length; n++)
    e.push(Y.getPlugin(s[n]));
  const i = o.plugins || [];
  for (let n = 0; n < i.length; n++) {
    const a = i[n];
    e.indexOf(a) === -1 && (e.push(a), t[a.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function Wi(o, t) {
  return !t && o === !1 ? null : o === !0 ? {} : o;
}
function Hi(o, { plugins: t, localIds: e }, s, i) {
  const n = [], a = o.getContext();
  for (const r of t) {
    const c = r.id, h = Wi(s[c], i);
    h !== null && n.push({
      plugin: r,
      options: $i(o.config, {
        plugin: r,
        local: e[c]
      }, h, a)
    });
  }
  return n;
}
function $i(o, { plugin: t, local: e }, s, i) {
  const n = o.pluginScopeKeys(t), a = o.getOptionScopes(s, n);
  return e && t.defaults && a.push(t.defaults), o.createResolver(a, i, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function qt(o, t) {
  const e = P.datasets[o] || {};
  return ((t.datasets || {})[o] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function Ui(o, t) {
  let e = o;
  return o === "_index_" ? e = t : o === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function Yi(o, t) {
  return o === t ? "_index_" : "_value_";
}
function Ce(o) {
  if (o === "x" || o === "y" || o === "r")
    return o;
}
function Xi(o) {
  if (o === "top" || o === "bottom")
    return "x";
  if (o === "left" || o === "right")
    return "y";
}
function Gt(o, ...t) {
  if (Ce(o))
    return o;
  for (const e of t) {
    const s = e.axis || Xi(e.position) || o.length > 1 && Ce(o[0].toLowerCase());
    if (s)
      return s;
  }
  throw new Error(`Cannot determine type of '${o}' axis. Please provide 'axis' or 'position' option.`);
}
function Ee(o, t, e) {
  if (e[t + "AxisID"] === o)
    return {
      axis: t
    };
}
function Ki(o, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((s) => s.xAxisID === o || s.yAxisID === o);
    if (e.length)
      return Ee(o, "x", e[0]) || Ee(o, "y", e[0]);
  }
  return {};
}
function qi(o, t) {
  const e = rt[o.type] || {
    scales: {}
  }, s = t.scales || {}, i = qt(o.type, t), n = /* @__PURE__ */ Object.create(null);
  return Object.keys(s).forEach((a) => {
    const r = s[a];
    if (!I(r))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (r._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const c = Gt(a, r, Ki(a, o), P.scales[r.type]), h = Yi(c, i), l = e.scales || {};
    n[a] = Ot(/* @__PURE__ */ Object.create(null), [
      {
        axis: c
      },
      r,
      l[c],
      l[h]
    ]);
  }), o.data.datasets.forEach((a) => {
    const r = a.type || o.type, c = a.indexAxis || qt(r, t), l = (rt[r] || {}).scales || {};
    Object.keys(l).forEach((d) => {
      const u = Ui(d, c), f = a[u + "AxisID"] || u;
      n[f] = n[f] || /* @__PURE__ */ Object.create(null), Ot(n[f], [
        {
          axis: u
        },
        s[f],
        l[d]
      ]);
    });
  }), Object.keys(n).forEach((a) => {
    const r = n[a];
    Ot(r, [
      P.scales[r.type],
      P.scale
    ]);
  }), n;
}
function ns(o) {
  const t = o.options || (o.options = {});
  t.plugins = z(t.plugins, {}), t.scales = qi(o, t);
}
function os(o) {
  return o = o || {}, o.datasets = o.datasets || [], o.labels = o.labels || [], o;
}
function Gi(o) {
  return o = o || {}, o.data = os(o.data), ns(o), o;
}
const Pe = /* @__PURE__ */ new Map(), as = /* @__PURE__ */ new Set();
function St(o, t) {
  let e = Pe.get(o);
  return e || (e = t(), Pe.set(o, e), as.add(e)), e;
}
const gt = (o, t, e) => {
  const s = It(t, e);
  s !== void 0 && o.add(s);
};
class Ji {
  constructor(t) {
    this._config = Gi(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = os(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), ns(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return St(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return St(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return St(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, s = this.type;
    return St(`${s}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const s = this._scopeCache;
    let i = s.get(t);
    return (!i || e) && (i = /* @__PURE__ */ new Map(), s.set(t, i)), i;
  }
  getOptionScopes(t, e, s) {
    const { options: i, type: n } = this, a = this._cachedScopes(t, s), r = a.get(e);
    if (r)
      return r;
    const c = /* @__PURE__ */ new Set();
    e.forEach((l) => {
      t && (c.add(t), l.forEach((d) => gt(c, t, d))), l.forEach((d) => gt(c, i, d)), l.forEach((d) => gt(c, rt[n] || {}, d)), l.forEach((d) => gt(c, P, d)), l.forEach((d) => gt(c, ie, d));
    });
    const h = Array.from(c);
    return h.length === 0 && h.push(/* @__PURE__ */ Object.create(null)), as.has(e) && a.set(e, h), h;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      rt[e] || {},
      P.datasets[e] || {},
      {
        type: e
      },
      P,
      ie
    ];
  }
  resolveNamedOptions(t, e, s, i = [
    ""
  ]) {
    const n = {
      $shared: !0
    }, { resolver: a, subPrefixes: r } = Le(this._resolverCache, t, i);
    let c = a;
    if (Qi(a, e)) {
      n.$shared = !1, s = zt(s) ? s() : s;
      const h = this.createResolver(t, s, r);
      c = ne(a, s, h);
    }
    for (const h of e)
      n[h] = c[h];
    return n;
  }
  createResolver(t, e, s = [
    ""
  ], i) {
    const { resolver: n } = Le(this._resolverCache, t, s);
    return I(e) ? ne(n, e, void 0, i) : n;
  }
}
function Le(o, t, e) {
  let s = o.get(t);
  s || (s = /* @__PURE__ */ new Map(), o.set(t, s));
  const i = e.join();
  let n = s.get(i);
  return n || (n = {
    resolver: ks(t, e),
    subPrefixes: e.filter((r) => !r.toLowerCase().includes("hover"))
  }, s.set(i, n)), n;
}
const Zi = (o) => I(o) && Object.getOwnPropertyNames(o).some((t) => zt(o[t]));
function Qi(o, t) {
  const { isScriptable: e, isIndexable: s } = Ms(o);
  for (const i of t) {
    const n = e(i), a = s(i), r = (a || n) && o[i];
    if (n && (zt(r) || Zi(r)) || a && q(r))
      return !0;
  }
  return !1;
}
var tn = "4.5.0";
const en = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Ie(o, t) {
  return o === "top" || o === "bottom" || en.indexOf(o) === -1 && t === "x";
}
function Re(o, t) {
  return function(e, s) {
    return e[o] === s[o] ? e[t] - s[t] : e[o] - s[o];
  };
}
function Te(o) {
  const t = o.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), A(e && e.onComplete, [
    o
  ], t);
}
function sn(o) {
  const t = o.chart, e = t.options.animation;
  A(e && e.onProgress, [
    o
  ], t);
}
function rs(o) {
  return Ke() && typeof o == "string" ? o = document.getElementById(o) : o && o.length && (o = o[0]), o && o.canvas && (o = o.canvas), o;
}
const Ct = {}, ze = (o) => {
  const t = rs(o);
  return Object.values(Ct).filter((e) => e.canvas === t).pop();
};
function nn(o, t, e) {
  const s = Object.keys(o);
  for (const i of s) {
    const n = +i;
    if (n >= t) {
      const a = o[i];
      delete o[i], (e > 0 || n > t) && (o[n + e] = a);
    }
  }
}
function on(o, t, e, s) {
  return !e || o.type === "mouseout" ? null : s ? t : o;
}
class an {
  static defaults = P;
  static instances = Ct;
  static overrides = rt;
  static registry = Y;
  static version = tn;
  static getChart = ze;
  static register(...t) {
    Y.add(...t), Fe();
  }
  static unregister(...t) {
    Y.remove(...t), Fe();
  }
  constructor(t, e) {
    const s = this.config = new Ji(e), i = rs(t), n = ze(i);
    if (n)
      throw new Error("Canvas is already in use. Chart with ID '" + n.id + "' must be destroyed before the canvas with ID '" + n.canvas.id + "' can be reused.");
    const a = s.createResolver(s.chartOptionScopes(), this.getContext());
    this.platform = new (s.platform || ki(i))(), this.platform.updateConfig(s);
    const r = this.platform.acquireContext(i, a.aspectRatio), c = r && r.canvas, h = c && c.height, l = c && c.width;
    if (this.id = cs(), this.ctx = r, this.canvas = c, this.width = l, this.height = h, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new ji(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = hs((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], Ct[this.id] = this, !r || !c) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    K.listen(this, "complete", Te), K.listen(this, "progress", sn), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: s, height: i, _aspectRatio: n } = this;
    return $(t) ? e && n ? n : i ? s / i : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Y;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Qt(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return te(this.canvas, this.ctx), this;
  }
  stop() {
    return K.stop(this), this;
  }
  resize(t, e) {
    K.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const s = this.options, i = this.canvas, n = s.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(i, t, e, n), r = s.devicePixelRatio || this.platform.getDevicePixelRatio(), c = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, Qt(this, r, !0) && (this.notifyPlugins("resize", {
      size: a
    }), A(s.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(c) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    T(e, (s, i) => {
      s.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, s = this.scales, i = Object.keys(s).reduce((a, r) => (a[r] = !1, a), {});
    let n = [];
    e && (n = n.concat(Object.keys(e).map((a) => {
      const r = e[a], c = Gt(a, r), h = c === "r", l = c === "x";
      return {
        options: r,
        dposition: h ? "chartArea" : l ? "bottom" : "left",
        dtype: h ? "radialLinear" : l ? "category" : "linear"
      };
    }))), T(n, (a) => {
      const r = a.options, c = r.id, h = Gt(c, r), l = z(r.type, a.dtype);
      (r.position === void 0 || Ie(r.position, h) !== Ie(a.dposition)) && (r.position = a.dposition), i[c] = !0;
      let d = null;
      if (c in s && s[c].type === l)
        d = s[c];
      else {
        const u = Y.getScale(l);
        d = new u({
          id: c,
          type: l,
          ctx: this.ctx,
          chart: this
        }), s[d.id] = d;
      }
      d.init(r, t);
    }), T(i, (a, r) => {
      a || delete s[r];
    }), T(s, (a) => {
      kt.configure(this, a, a.options), kt.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, s = t.length;
    if (t.sort((i, n) => i.index - n.index), s > e) {
      for (let i = e; i < s; ++i)
        this._destroyDatasetMeta(i);
      t.splice(e, s - e);
    }
    this._sortedMetasets = t.slice(0).sort(Re("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((s, i) => {
      e.filter((n) => n === s._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let s, i;
    for (this._removeUnreferencedMetasets(), s = 0, i = e.length; s < i; s++) {
      const n = e[s];
      let a = this.getDatasetMeta(s);
      const r = n.type || this.config.type;
      if (a.type && a.type !== r && (this._destroyDatasetMeta(s), a = this.getDatasetMeta(s)), a.type = r, a.indexAxis = n.indexAxis || qt(r, this.options), a.order = n.order || 0, a.index = s, a.label = "" + n.label, a.visible = this.isDatasetVisible(s), a.controller)
        a.controller.updateIndex(s), a.controller.linkScales();
      else {
        const c = Y.getController(r), { datasetElementType: h, dataElementType: l } = P.datasets[r];
        Object.assign(c, {
          dataElementType: Y.getElement(l),
          datasetElementType: h && Y.getElement(h)
        }), a.controller = new c(this, s), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    T(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const s = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !s.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const n = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let h = 0, l = this.data.datasets.length; h < l; h++) {
      const { controller: d } = this.getDatasetMeta(h), u = !i && n.indexOf(d) === -1;
      d.buildOrUpdateElements(u), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = s.layout.autoPadding ? a : 0, this._updateLayout(a), i || T(n, (h) => {
      h.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Re("z", "_idx"));
    const { _active: r, _lastEvent: c } = this;
    c ? this._eventHandler(c, !0) : r.length && this._updateHoverStyles(r, r, !0), this.render();
  }
  _updateScales() {
    T(this.scales, (t) => {
      kt.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), s = new Set(t.events);
    (!ee(e, s) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: s, start: i, count: n } of e) {
      const a = s === "_removeElements" ? -n : n;
      nn(t, i, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, s = (n) => new Set(t.filter((a) => a[0] === n).map((a, r) => r + "," + a.splice(1).join(","))), i = s(0);
    for (let n = 1; n < e; n++)
      if (!ee(i, s(n)))
        return;
    return Array.from(i).map((n) => n.split(",")).map((n) => ({
      method: n[1],
      start: +n[2],
      count: +n[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    kt.update(this, this.width, this.height, t);
    const e = this.chartArea, s = e.width <= 0 || e.height <= 0;
    this._layers = [], T(this.boxes, (i) => {
      s && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, n) => {
      i._idx = n;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, s = this.data.datasets.length; e < s; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, s = this.data.datasets.length; e < s; ++e)
        this._updateDataset(e, zt(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const s = this.getDatasetMeta(t), i = {
      meta: s,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (s.controller._update(e), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (K.has(this) ? this.attached && !K.running(this) && K.start(this) : (this.draw(), Te({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: s, height: i } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(s, i);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, s = [];
    let i, n;
    for (i = 0, n = e.length; i < n; ++i) {
      const a = e[i];
      (!t || a.visible) && s.push(a);
    }
    return s;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, s = {
      meta: t,
      index: t.index,
      cancelable: !0
    }, i = ls(this, t);
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (i && $e(e, i), t.controller.draw(), i && Ue(e), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(t) {
    return Ye(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, s, i) {
    const n = ei.modes[e];
    return typeof n == "function" ? n(this, t, s, i) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], s = this._metasets;
    let i = s.filter((n) => n && n._dataset === e).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, s.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = xt(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const s = this.getDatasetMeta(t);
    return typeof s.hidden == "boolean" ? !s.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const s = this.getDatasetMeta(t);
    s.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, s) {
    const i = s ? "show" : "hide", n = this.getDatasetMeta(t), a = n.controller._resolveAnimations(void 0, i);
    Et(e) ? (n.data[e].hidden = !s, this.update()) : (this.setDatasetVisibility(t, s), a.update(n, {
      visible: s
    }), this.update((r) => r.datasetIndex === t ? i : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), K.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), te(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete Ct[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, s = (n, a) => {
      e.addEventListener(this, n, a), t[n] = a;
    }, i = (n, a, r) => {
      n.offsetX = a, n.offsetY = r, this._eventHandler(n);
    };
    T(this.options.events, (n) => s(n, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, s = (c, h) => {
      e.addEventListener(this, c, h), t[c] = h;
    }, i = (c, h) => {
      t[c] && (e.removeEventListener(this, c, h), delete t[c]);
    }, n = (c, h) => {
      this.canvas && this.resize(c, h);
    };
    let a;
    const r = () => {
      i("attach", r), this.attached = !0, this.resize(), s("resize", n), s("detach", a);
    };
    a = () => {
      this.attached = !1, i("resize", n), this._stop(), this._resize(0, 0), s("attach", r);
    }, e.isAttached(this.canvas) ? r() : a();
  }
  unbindEvents() {
    T(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, T(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, s) {
    const i = s ? "set" : "remove";
    let n, a, r, c;
    for (e === "dataset" && (n = this.getDatasetMeta(t[0].datasetIndex), n.controller["_" + i + "DatasetHoverStyle"]()), r = 0, c = t.length; r < c; ++r) {
      a = t[r];
      const h = a && this.getDatasetMeta(a.datasetIndex).controller;
      h && h[i + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], s = t.map(({ datasetIndex: n, index: a }) => {
      const r = this.getDatasetMeta(n);
      if (!r)
        throw new Error("No dataset found at index " + n);
      return {
        datasetIndex: n,
        element: r.data[a],
        index: a
      };
    });
    !se(s, e) && (this._active = s, this._lastEvent = null, this._updateHoverStyles(s, e));
  }
  notifyPlugins(t, e, s) {
    return this._plugins.notify(this, t, e, s);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, s) {
    const i = this.options.hover, n = (c, h) => c.filter((l) => !h.some((d) => l.datasetIndex === d.datasetIndex && l.index === d.index)), a = n(e, t), r = s ? t : n(t, e);
    a.length && this.updateHoverStyle(a, i.mode, !1), r.length && i.mode && this.updateHoverStyle(r, i.mode, !0);
  }
  _eventHandler(t, e) {
    const s = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, i = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", s, i) === !1)
      return;
    const n = this._handleEvent(t, e, s.inChartArea);
    return s.cancelable = !1, this.notifyPlugins("afterEvent", s, i), (n || s.changed) && this.render(), this;
  }
  _handleEvent(t, e, s) {
    const { _active: i = [], options: n } = this, a = e, r = this._getActiveElements(t, i, s, a), c = ds(t), h = on(t, this._lastEvent, s, c);
    s && (this._lastEvent = null, A(n.onHover, [
      t,
      r,
      this
    ], this), c && A(n.onClick, [
      t,
      r,
      this
    ], this));
    const l = !se(r, i);
    return (l || e) && (this._active = r, this._updateHoverStyles(r, i, e)), this._lastEvent = h, l;
  }
  _getActiveElements(t, e, s, i) {
    if (t.type === "mouseout")
      return [];
    if (!s)
      return e;
    const n = this.options.hover;
    return this.getElementsAtEventForMode(t, n.mode, n, i);
  }
}
function Fe() {
  return T(an.instances, (o) => o._plugins.invalidate());
}
function rn(o, t, e) {
  const { startAngle: s, x: i, y: n, outerRadius: a, innerRadius: r, options: c } = t, { borderWidth: h, borderJoinStyle: l } = c, d = Math.min(h / a, jt(s - e));
  if (o.beginPath(), o.arc(i, n, a - h / 2, s + d / 2, e - d / 2), r > 0) {
    const u = Math.min(h / r, jt(s - e));
    o.arc(i, n, r + h / 2, e - u / 2, s + u / 2, !0);
  } else {
    const u = Math.min(h / 2, a * jt(s - e));
    if (l === "round")
      o.arc(i, n, u, e - H / 2, s + H / 2, !0);
    else if (l === "bevel") {
      const f = 2 * u * u, g = -f * Math.cos(e + H / 2) + i, m = -f * Math.sin(e + H / 2) + n, x = f * Math.cos(s + H / 2) + i, p = f * Math.sin(s + H / 2) + n;
      o.lineTo(g, m), o.lineTo(x, p);
    }
  }
  o.closePath(), o.moveTo(0, 0), o.rect(0, 0, o.canvas.width, o.canvas.height), o.clip("evenodd");
}
function cn(o, t, e) {
  const { startAngle: s, pixelMargin: i, x: n, y: a, outerRadius: r, innerRadius: c } = t;
  let h = i / r;
  o.beginPath(), o.arc(n, a, r, s - h, e + h), c > i ? (h = i / c, o.arc(n, a, c, e + h, s - h, !0)) : o.arc(n, a, i, e + X, s - X), o.closePath(), o.clip();
}
function hn(o) {
  return As(o, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function ln(o, t, e, s) {
  const i = hn(o.options.borderRadius), n = (e - t) / 2, a = Math.min(n, s * t / 2), r = (c) => {
    const h = (e - Math.min(n, c)) * s / 2;
    return G(c, 0, Math.min(n, h));
  };
  return {
    outerStart: r(i.outerStart),
    outerEnd: r(i.outerEnd),
    innerStart: G(i.innerStart, 0, a),
    innerEnd: G(i.innerEnd, 0, a)
  };
}
function at(o, t, e, s) {
  return {
    x: e + o * Math.cos(t),
    y: s + o * Math.sin(t)
  };
}
function Tt(o, t, e, s, i, n) {
  const { x: a, y: r, startAngle: c, pixelMargin: h, innerRadius: l } = t, d = Math.max(t.outerRadius + s + e - h, 0), u = l > 0 ? l + s + e + h : 0;
  let f = 0;
  const g = i - c;
  if (s) {
    const k = l > 0 ? l - s : 0, w = d > 0 ? d - s : 0, O = (k + w) / 2, W = O !== 0 ? g * O / (O + s) : g;
    f = (g - W) / 2;
  }
  const m = Math.max(1e-3, g * d - e / H) / d, x = (g - m) / 2, p = c + x + f, _ = i - x - f, { outerStart: b, outerEnd: v, innerStart: y, innerEnd: S } = ln(t, u, d, _ - p), D = d - b, L = d - v, E = p + b / D, M = _ - v / L, F = u + y, C = u + S, N = p + y / F, B = _ - S / C;
  if (o.beginPath(), n) {
    const k = (E + M) / 2;
    if (o.arc(a, r, d, E, k), o.arc(a, r, d, k, M), v > 0) {
      const R = at(L, M, a, r);
      o.arc(R.x, R.y, v, M, _ + X);
    }
    const w = at(C, _, a, r);
    if (o.lineTo(w.x, w.y), S > 0) {
      const R = at(C, B, a, r);
      o.arc(R.x, R.y, S, _ + X, B + Math.PI);
    }
    const O = (_ - S / u + (p + y / u)) / 2;
    if (o.arc(a, r, u, _ - S / u, O, !0), o.arc(a, r, u, O, p + y / u, !0), y > 0) {
      const R = at(F, N, a, r);
      o.arc(R.x, R.y, y, N + Math.PI, p - X);
    }
    const W = at(D, p, a, r);
    if (o.lineTo(W.x, W.y), b > 0) {
      const R = at(D, E, a, r);
      o.arc(R.x, R.y, b, p - X, E);
    }
  } else {
    o.moveTo(a, r);
    const k = Math.cos(E) * d + a, w = Math.sin(E) * d + r;
    o.lineTo(k, w);
    const O = Math.cos(M) * d + a, W = Math.sin(M) * d + r;
    o.lineTo(O, W);
  }
  o.closePath();
}
function dn(o, t, e, s, i) {
  const { fullCircles: n, startAngle: a, circumference: r } = t;
  let c = t.endAngle;
  if (n) {
    Tt(o, t, e, s, c, i);
    for (let h = 0; h < n; ++h)
      o.fill();
    isNaN(r) || (c = a + (r % j || j));
  }
  return Tt(o, t, e, s, c, i), o.fill(), c;
}
function un(o, t, e, s, i) {
  const { fullCircles: n, startAngle: a, circumference: r, options: c } = t, { borderWidth: h, borderJoinStyle: l, borderDash: d, borderDashOffset: u, borderRadius: f } = c, g = c.borderAlign === "inner";
  if (!h)
    return;
  o.setLineDash(d || []), o.lineDashOffset = u, g ? (o.lineWidth = h * 2, o.lineJoin = l || "round") : (o.lineWidth = h, o.lineJoin = l || "bevel");
  let m = t.endAngle;
  if (n) {
    Tt(o, t, e, s, m, i);
    for (let x = 0; x < n; ++x)
      o.stroke();
    isNaN(r) || (m = a + (r % j || j));
  }
  g && cn(o, t, m), c.selfJoin && m - a >= H && f === 0 && l !== "miter" && rn(o, t, m), n || (Tt(o, t, e, s, m, i), o.stroke());
}
class xn extends Zt {
  static id = "arc";
  static defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: void 0,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: void 0,
    circular: !0,
    selfJoin: !1
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor"
  };
  static descriptors = {
    _scriptable: !0,
    _indexable: (t) => t !== "borderDash"
  };
  circumference;
  endAngle;
  fullCircles;
  innerRadius;
  outerRadius;
  pixelMargin;
  startAngle;
  constructor(t) {
    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, e, s) {
    const i = this.getProps([
      "x",
      "y"
    ], s), { angle: n, distance: a } = Xe(i, {
      x: t,
      y: e
    }), { startAngle: r, endAngle: c, innerRadius: h, outerRadius: l, circumference: d } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], s), u = (this.options.spacing + this.options.borderWidth) / 2, f = z(d, c - r), g = Pt(n, r, c) && r !== c, m = f >= j || g, x = us(a, h + u, l + u);
    return m && x;
  }
  getCenterPoint(t) {
    const { x: e, y: s, startAngle: i, endAngle: n, innerRadius: a, outerRadius: r } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], t), { offset: c, spacing: h } = this.options, l = (i + n) / 2, d = (a + r + h + c) / 2;
    return {
      x: e + Math.cos(l) * d,
      y: s + Math.sin(l) * d
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: e, circumference: s } = this, i = (e.offset || 0) / 4, n = (e.spacing || 0) / 2, a = e.circular;
    if (this.pixelMargin = e.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = s > j ? Math.floor(s / j) : 0, s === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    const r = (this.startAngle + this.endAngle) / 2;
    t.translate(Math.cos(r) * i, Math.sin(r) * i);
    const c = 1 - Math.sin(Math.min(H, s || 0)), h = i * c;
    t.fillStyle = e.backgroundColor, t.strokeStyle = e.borderColor, dn(t, this, h, n, a), un(t, this, h, n, a), t.restore();
  }
}
const Nt = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, V = /* @__PURE__ */ Object.keys(Nt);
function Ve(o, t) {
  return o - t;
}
function Ne(o, t) {
  if ($(t))
    return null;
  const e = o._adapter, { parser: s, round: i, isoWeekday: n } = o._parseOpts;
  let a = t;
  return typeof s == "function" && (a = s(a)), J(a) || (a = typeof s == "string" ? e.parse(a, s) : e.parse(a)), a === null ? null : (i && (a = i === "week" && (Lt(n) || n === !0) ? e.startOf(a, "isoWeek", n) : e.startOf(a, i)), +a);
}
function je(o, t, e, s) {
  const i = V.length;
  for (let n = V.indexOf(o); n < i - 1; ++n) {
    const a = Nt[V[n]], r = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((e - t) / (r * a.size)) <= s)
      return V[n];
  }
  return V[i - 1];
}
function fn(o, t, e, s, i) {
  for (let n = V.length - 1; n >= V.indexOf(e); n--) {
    const a = V[n];
    if (Nt[a].common && o._adapter.diff(i, s, a) >= t - 1)
      return a;
  }
  return V[e ? V.indexOf(e) : 0];
}
function gn(o) {
  for (let t = V.indexOf(o) + 1, e = V.length; t < e; ++t)
    if (Nt[V[t]].common)
      return V[t];
}
function Be(o, t, e) {
  if (!e)
    o[t] = !0;
  else if (e.length) {
    const { lo: s, hi: i } = Is(e, t), n = e[s] >= t ? e[s] : e[i];
    o[n] = !0;
  }
}
function pn(o, t, e, s) {
  const i = o._adapter, n = +i.startOf(t[0].value, s), a = t[t.length - 1].value;
  let r, c;
  for (r = n; r <= a; r = +i.add(r, 1, s))
    c = e[r], c >= 0 && (t[c].major = !0);
  return t;
}
function We(o, t, e) {
  const s = [], i = {}, n = t.length;
  let a, r;
  for (a = 0; a < n; ++a)
    r = t[a], i[r] = a, s.push({
      value: r,
      major: !1
    });
  return n === 0 || !e ? s : pn(o, s, i, e);
}
class He extends Vt {
  static id = "time";
  static defaults = {
    bounds: "data",
    adapters: {},
    time: {
      parser: !1,
      unit: !1,
      round: !1,
      isoWeekday: !1,
      minUnit: "millisecond",
      displayFormats: {}
    },
    ticks: {
      source: "auto",
      callback: !1,
      major: {
        enabled: !1
      }
    }
  };
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e = {}) {
    const s = t.time || (t.time = {}), i = this._adapter = new Gs._date(t.adapters.date);
    i.init(e), Ot(s.displayFormats, i.formats()), this._parseOpts = {
      parser: s.parser,
      round: s.round,
      isoWeekday: s.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : Ne(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, s = t.time.unit || "day";
    let { min: i, max: n, minDefined: a, maxDefined: r } = this.getUserBounds();
    function c(h) {
      !a && !isNaN(h.min) && (i = Math.min(i, h.min)), !r && !isNaN(h.max) && (n = Math.max(n, h.max));
    }
    (!a || !r) && (c(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && c(this.getMinMax(!1))), i = J(i) && !isNaN(i) ? i : +e.startOf(Date.now(), s), n = J(n) && !isNaN(n) ? n : +e.endOf(Date.now(), s) + 1, this.min = Math.min(i, n - 1), this.max = Math.max(i + 1, n);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], s = t[t.length - 1]), {
      min: e,
      max: s
    };
  }
  buildTicks() {
    const t = this.options, e = t.time, s = t.ticks, i = s.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const n = this.min, a = this.max, r = Ps(i, n, a);
    return this._unit = e.unit || (s.autoSkip ? je(e.minUnit, this.min, this.max, this._getLabelCapacity(n)) : fn(this, r.length, e.minUnit, this.min, this.max)), this._majorUnit = !s.major.enabled || this._unit === "year" ? void 0 : gn(this._unit), this.initOffsets(i), t.reverse && r.reverse(), We(this, r, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let e = 0, s = 0, i, n;
    this.options.offset && t.length && (i = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - i : e = (this.getDecimalForValue(t[1]) - i) / 2, n = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? s = n : s = (n - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    e = G(e, 0, a), s = G(s, 0, a), this._offsets = {
      start: e,
      end: s,
      factor: 1 / (e + 1 + s)
    };
  }
  _generate() {
    const t = this._adapter, e = this.min, s = this.max, i = this.options, n = i.time, a = n.unit || je(n.minUnit, e, s, this._getLabelCapacity(e)), r = z(i.ticks.stepSize, 1), c = a === "week" ? n.isoWeekday : !1, h = Lt(c) || c === !0, l = {};
    let d = e, u, f;
    if (h && (d = +t.startOf(d, "isoWeek", c)), d = +t.startOf(d, h ? "day" : a), t.diff(s, e, a) > 1e5 * r)
      throw new Error(e + " and " + s + " are too far apart with stepSize of " + r + " " + a);
    const g = i.ticks.source === "data" && this.getDataTimestamps();
    for (u = d, f = 0; u < s; u = +t.add(u, r, a), f++)
      Be(l, u, g);
    return (u === s || i.bounds === "ticks" || f === 1) && Be(l, u, g), Object.keys(l).sort(Ve).map((m) => +m);
  }
  getLabelForValue(t) {
    const e = this._adapter, s = this.options.time;
    return s.tooltipFormat ? e.format(t, s.tooltipFormat) : e.format(t, s.displayFormats.datetime);
  }
  format(t, e) {
    const i = this.options.time.displayFormats, n = this._unit, a = e || i[n];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, e, s, i) {
    const n = this.options, a = n.ticks.callback;
    if (a)
      return A(a, [
        t,
        e,
        s
      ], this);
    const r = n.time.displayFormats, c = this._unit, h = this._majorUnit, l = c && r[c], d = h && r[h], u = s[e], f = h && d && u && u.major;
    return this._adapter.format(t, i || (f ? d : l));
  }
  generateTickLabels(t) {
    let e, s, i;
    for (e = 0, s = t.length; e < s; ++e)
      i = t[e], i.label = this._tickFormatFunction(i.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, s = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + s) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, s = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + s * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, s = this.ctx.measureText(t).width, i = it(this.isHorizontal() ? e.maxRotation : e.minRotation), n = Math.cos(i), a = Math.sin(i), r = this._resolveTickFontOptions(0).size;
    return {
      w: s * n + r * a,
      h: s * a + r * n
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, s = e.displayFormats, i = s[e.unit] || s.millisecond, n = this._tickFormatFunction(t, 0, We(this, [
      t
    ], this._majorUnit), i), a = this._getLabelSize(n), r = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return r > 0 ? r : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, s;
    if (t.length)
      return t;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (e = 0, s = i.length; e < s; ++e)
      t = t.concat(i[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, s;
    if (t.length)
      return t;
    const i = this.getLabels();
    for (e = 0, s = i.length; e < s; ++e)
      t.push(Ne(this, i[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return Ls(t.sort(Ve));
  }
}
function Dt(o, t, e) {
  let s = 0, i = o.length - 1, n, a, r, c;
  e ? (t >= o[s].pos && t <= o[i].pos && ({ lo: s, hi: i } = Kt(o, "pos", t)), { pos: n, time: r } = o[s], { pos: a, time: c } = o[i]) : (t >= o[s].time && t <= o[i].time && ({ lo: s, hi: i } = Kt(o, "time", t)), { time: n, pos: r } = o[s], { time: a, pos: c } = o[i]);
  const h = a - n;
  return h ? r + (c - r) * (t - n) / h : r;
}
class bn extends He {
  static id = "timeseries";
  static defaults = He.defaults;
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = Dt(e, this.min), this._tableRange = Dt(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: s } = this, i = [], n = [];
    let a, r, c, h, l;
    for (a = 0, r = t.length; a < r; ++a)
      h = t[a], h >= e && h <= s && i.push(h);
    if (i.length < 2)
      return [
        {
          time: e,
          pos: 0
        },
        {
          time: s,
          pos: 1
        }
      ];
    for (a = 0, r = i.length; a < r; ++a)
      l = i[a + 1], c = i[a - 1], h = i[a], Math.round((l + c) / 2) !== h && n.push({
        time: h,
        pos: a / (r - 1)
      });
    return n;
  }
  _generate() {
    const t = this.min, e = this.max;
    let s = super.getDataTimestamps();
    return (!s.includes(t) || !s.length) && s.splice(0, 0, t), (!s.includes(e) || s.length === 1) && s.push(e), s.sort((i, n) => i - n);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), s = this.getLabelTimestamps();
    return e.length && s.length ? t = this.normalize(e.concat(s)) : t = e.length ? e : s, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Dt(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, s = this.getDecimalForPixel(t) / e.factor - e.end;
    return Dt(this._table, s * this._tableRange + this._minPos, !0);
  }
}
export {
  zs as Animation,
  Fs as Animations,
  xn as ArcElement,
  es as BasePlatform,
  hi as BasicPlatform,
  an as Chart,
  Ze as DatasetController,
  vi as DomPlatform,
  _n as DoughnutController,
  Zt as Element,
  ei as Interaction,
  Vt as Scale,
  kn as Ticks,
  He as TimeScale,
  bn as TimeSeriesScale,
  Gs as _adapters,
  ki as _detectPlatform,
  K as animator,
  P as defaults,
  kt as layouts,
  Y as registry
};
//# sourceMappingURL=index.es222.js.map
